import React from 'react'
import { CardTitle, Input } from 'reactstrap'
import PropTypes from 'prop-types'

import ImportStatus from './ImportStatus'
import Menu from './Menu'
import { truncateString } from '../../../helpers/StringHelpers'

const Header = ({
  isAdmin = false,
  isSelected = false,
  onClickDelete,
  onClickEdit,
  onClickForceImport,
  onClickForceReImport,
  onSelect = () => {},
  project: {
    id,
    import_stats: importStats,
    logo_data_url: logoDataUrl,
    name,
    state,
    to_be_deleted: toBeDeleted
  },
  showCheckbox = false
}) => {
  const showLogo = logoDataUrl && !showCheckbox
  const hasLeadingElement = showLogo || showCheckbox

  return (
    <>
      <div
        className="d-flex flex-row justify-content-between"
        style={{ height: '50px' }}
      >
        <CardTitle
          tag="h5"
          title={name}
          className="d-flex align-items-center gap-2"
        >
          {showCheckbox && (
            <Input
              checked={isSelected}
              className="m-0"
              onChange={(e) => onSelect(e.target.checked)}
              style={{
                width: '20px',
                height: '20px',
                cursor: 'pointer',
                flexShrink: 0
              }}
              type="checkbox"
            />
          )}
          {showLogo && (
            <img
              src={logoDataUrl}
              alt=""
              style={{
                width: '24px',
                height: '24px',
                borderRadius: '4px',
                objectFit: 'cover',
                flexShrink: 0
              }}
            />
          )}
          <span>{truncateString(name, hasLeadingElement ? 22 : 30)}</span>
        </CardTitle>

        {isAdmin
          && toBeDeleted === false
          && !['pending', 'importing'].includes(state)
          && (
            <Menu
              onClickDelete={() => onClickDelete()}
              onClickEdit={() => onClickEdit()}
              onClickForceImport={() => onClickForceImport()}
              onClickForceReImport={() => onClickForceReImport()}
              state={state}
            />
          )}
      </div>

      <hr
        className="mt-0 mb-2"
        style={{
          marginLeft: '-1rem',
          marginRight: '-1rem',
          width: 'calc(100% + 2rem)'
        }}
      />

      {toBeDeleted === false && (
        <ImportStatus
          importStats={importStats}
          isAdmin={isAdmin}
          projectId={id}
          state={state}
        />
      )}
    </>
  )
}

Header.propTypes = {
  isAdmin: PropTypes.bool,
  isSelected: PropTypes.bool,
  onClickDelete: PropTypes.func.isRequired,
  onClickEdit: PropTypes.func.isRequired,
  onClickForceImport: PropTypes.func.isRequired,
  onClickForceReImport: PropTypes.func.isRequired,
  onSelect: PropTypes.func,
  project: PropTypes.shape({
    id: PropTypes.string.isRequired,
    import_stats: PropTypes.shape(),
    logo_data_url: PropTypes.string,
    name: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    to_be_deleted: PropTypes.bool
  }).isRequired,
  showCheckbox: PropTypes.bool
}

export default Header
